@if (isLoading()) {
  <div class="card-spacer-box">
    <app-loader></app-loader>
  </div>
} @else if (hasError()) {
  <div class="position-relative d-inline-block">
    <app-virtual-card-static [cardDetail]="cardDetailFailed()"></app-virtual-card-static>
    <button
      class="reload-card-detail"
      (click)="reloadCardData()">
      <span class="text"><i class="iconoir-refresh-double"></i> Reload card details</span>
    </button>
  </div>
} @else {
  <div
    class="card-iframe-wrapper"
    [ngClass]="{ 'loaded': !isLoadingCard() }">
    @if (isLoadingCard()) {
      <div>
        <app-virtual-card-static
          [isLoading]="isLoadingCard()"
          [cardDetail]="cardDetailEmpty()"></app-virtual-card-static>
      </div>
    }
    @if (iframeSrc()) {
      <iframe
        #iframe
        [src]="iframeSrc()"
        width="334"
        height="205"
        title="Virtual Card"
        allow="clipboard-write">
      </iframe>
    }
  </div>
}
